import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

interface SimpleSplitTextProps {
  text: string;
  delay?: number;
  duration?: number;
  splitType?: 'chars' | 'words';
  textAlign?: 'left' | 'center' | 'right';
}

const SimpleSplitText: React.FC<SimpleSplitTextProps> = ({ 
  text,
  delay = 80,
  duration = 0.5,
  splitType = 'chars',
  textAlign = 'center'
}) => {
  const [animationKey, setAnimationKey] = React.useState(0);

  useEffect(() => {
    // Automatische Wiederholung alle 4 Sekunden (wie Blur Text)
    const interval = setInterval(() => {
      setAnimationKey(prev => prev + 1);
    }, 4000);
    
    return () => clearInterval(interval);
  }, []);

  const elements = React.useMemo(() => {
    return splitType === 'chars' ? text.split('') : text.split(' ');
  }, [text, splitType]);

  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: delay / 1000,
        delayChildren: 0.1,
      },
    },
  };

  const childVariants = {
    hidden: {
      opacity: 0,
      y: 40,
      scale: 0.8,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration,
        ease: [0.25, 0.46, 0.45, 0.94] as const,
      },
    },
  };

  return (
    <motion.div
      key={animationKey}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      style={{
        textAlign,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        fontSize: 'clamp(1rem, 3vw, 2.5rem)',
        fontWeight: 700,
        color: '#ffffff',
        lineHeight: 1.2,
        margin: 0,
      }}
    >
      {elements.map((element, index) => {
        const isSpace = element === ' ';
        
        return (
          <motion.span
            key={index}
            variants={childVariants}
            style={{
              display: 'inline-block',
              marginRight: splitType === 'words' ? '0.25em' : '0',
              willChange: 'transform, opacity',
            }}
          >
            {isSpace ? '\u00A0' : element}
            {splitType === 'words' && index < elements.length - 1 && !isSpace && '\u00A0'}
          </motion.span>
        );
      })}
    </motion.div>
  );
};

export default SimpleSplitText;